<template>
    <div class="_menu">
        <div class="_menu_title">
            <div class="_menu_title_left">
                <Breadcrumb></Breadcrumb>
            </div>
            <div class="_menu_title_right">
                <el-button type="primary" icon="el-icon-plus" @click="showAddEditForm('new', null)">新增</el-button>
            </div>
        </div>
        <div class="_menu_content">
            <el-table :data="tableData" v-loading="loading" style="width: 100%;margin-bottom: 20px;" border row-key="Id"
                size="mini" :tree-props="{ children: 'Children', hasChildren: 'hasChildren' }">
                <el-table-column prop="T_name" label="菜单名称" width="180">
                </el-table-column>
                <el-table-column prop="T_permission" label="权限" width="180">
                </el-table-column>
                <el-table-column prop="T_sort" label="排序" width="100">
                </el-table-column>
                <el-table-column label="图标" width="100">
                    <template slot-scope="scope">
                        <span :class="`iconfont ${scope.row.T_icon}`"></span>
                    </template>
                </el-table-column>
                <el-table-column prop="T_type" label="类型" width="80">
                    <template slot-scope="scope">
                        {{ scope.row.T_type == 'M' ? '菜单(M)' : '按钮(B)' }}
                    </template>
                </el-table-column>
                <el-table-column prop="T_State" label="进入公司后展示" width="120">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.T_pid == '1' ? 'success' : 'danger'">{{ scope.row.T_pid == '1'
                            ? '是' : '否' }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label=" 操作" min-width="220">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini"
                            @click="showAddEditForm('sub', scope.row)">添加子菜单</el-button>
                        <el-button type="primary" size="mini" @click="showAddEditForm('edit', scope.row)">编辑</el-button>
                        <el-button type="danger" size="mini" @click="confirmDelete(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <AddEditForm ref="AddEditFormRef" @refresh="fetchMenuList"></AddEditForm>
    </div>
</template>

<script>
import { _MenuListAll, _MenuDel } from '@/api/_menu/index.js';
import AddEditForm from './modules/AddEditForm.vue';
export default {
    name: "Menu",
    components: {
        AddEditForm,
    },
    data() {
        return {
            loading: false,
            tableData: []
        };
    },
    mounted() {
        this.fetchMenuList();
    },
    methods: {
        fetchMenuList() {
            this.loading = true;
            _MenuListAll({}).then(({ data: res }) => {
                if (res.Code == 200) {
                    this.tableData = res.Data.Data;
                } else {
                    this.tableData = [];
                }
                this.loading = false;
            })
        },
        showAddEditForm(title, row) {
            this.$refs.AddEditFormRef.showDialogVisible(title, row);
        },
        confirmDelete(row) {
            this.$confirm('确认删除该菜单吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 确认删除
                _MenuDel({ T_id: row.Id }).then(({ data: res }) => {
                    if (res.Code == 200) {
                        this.$message.success('删除成功');
                        this.fetchMenuList();
                    } else {
                        this.$message.error('删除失败');
                    }
                })
            }).catch(() => { });
        },
    },
};
</script>
<style lang="scss">
._menu {
    ._menu_title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: rgba(#fff, 1);
        height: 70px;
        padding: 15px 10px;
        box-shadow: 5px 5px 10px -10px #000;

        ._menu_title_left {
            display: flex;
            align-items: center;
        }
    }

    ._menu_content {
        background: rgba(#fff, 1);
        margin: 10px;
        padding: 20px 30px;
        // height: calc(100vh - 120px);
        overflow-y: auto;
    }
}
</style>